// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { actionsStyles } from "@steiner/Overrides/Widgets/ProductList/ProductListTable";
import { ellipsis } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

actionsStyles.gridContainer = {
    gap: 0,
    css: css`
        min-width: 320px; /* prevent overlap with second column */
    `,
};
actionsStyles.wrapper = {
    css: css`
        overflow: auto;
        padding-top: 12px;
    `,
};

actionsStyles.productImageStyles = {
    productImage: {
        linkWrappingImage: {
            css: css`
                width: 68px;
                height: 68px;
            `,
        },
    },
};

actionsStyles.actionsCell = {};

actionsStyles.actionsHeader = {};

actionsStyles.productPriceAndActionsStyles = {
    productListGridContainer: {
        container: {
            css: css`
                & > .bottom-section {
                    display: flex;
                    flex-direction: row;
                    height: 100%;
                    gap: 12px;
                    padding-top: 0;
                    &:empty {
                        display: none;
                    }
                }
            `,
        },
        addToList: {
            css: css`
                justify-content: center;
            `,
        },
        addToCartActions: {
            css: css`
                flex: 1;
            `,
        },
    },
};

actionsStyles.availabilityCell = actionsStyles.availabilityHeader = {
    css: css`
        width: 200px;
        min-width: 200px;
    `,
};
actionsStyles.availabilityStyles = {
    messageText: {
        css: css`
            white-space: normal;
        `,
    },
};

actionsStyles.productInformationStyles = {
    descriptionStyles: {
        productDetailLink: {
            mergeCss: true,
            typographyProps: {
                css: css`
                    ${ellipsis(3)};
                `,
            },
        },
        productDetailDescription: {
            css: css`
                ${ellipsis(3)};
            `,
        },
    },
};
